export const FINANCIAL_VALUE_FORMAT_OPTIONS = {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
}
